import React, { useContext, useEffect, useState } from 'react';
import { DealSeats, CardSeats } from './BridgeTypes';
import { PlayStateContext } from './BridgeEnginePlay';
import './Dealer.css';

const Dealer: React.FC = () => {
    const playState = useContext(PlayStateContext)!;
    const [dealerSeat, setDealerSeat] = useState<DealSeats>(playState.boardState.dealerSeat);
    const [playerSeat, setPlayerSeat] = useState<DealSeats>(playState.boardState.playerSeat);
    const [gameCode, setGameCode] = useState<string>(playState.boardState.boardId);
    const [vulnerableSeats, setVulnerableSeats] = useState<DealSeats[]>(playState.boardState.vulnerableSeats);

    useEffect(() => {
        setDealerSeat(playState.boardState.dealerSeat);
        setPlayerSeat(playState.boardState.playerSeat);
        setGameCode(playState.boardState.boardId);
        setVulnerableSeats(playState.boardState.vulnerableSeats);
    }, [playState.boardState]);

    return (
        <div id="dealer-grid-container">
            <div id="b1" />
            <div id="dealer-north" style={{ backgroundColor: vulnerableSeats.includes(DealSeats.North) ? 'red' : 'white' }}>
                {dealerSeat === DealSeats.North ? 'D' : '\u00A0'}
            </div>
            <div id="b2" />
            <div id="dealer-west" style={{ backgroundColor: vulnerableSeats.includes(DealSeats.West) ? 'red' : 'white' }}>
                {dealerSeat === DealSeats.West ? 'D' : '\u00A0'}
            </div>
            <div id="dealer-game">{gameCode}{playerSeat.charAt(0).toUpperCase()}</div>
            <div id="dealer-east" style={{ backgroundColor: vulnerableSeats.includes(DealSeats.East) ? 'red' : 'white' }}>
                {dealerSeat === DealSeats.East ? 'D' : '\u00A0'}
            </div>
            <div id="b3" />
            <div id="dealer-south" style={{ backgroundColor: vulnerableSeats.includes(DealSeats.South) ? 'red' : 'white' }}>
                {dealerSeat === DealSeats.South ? 'D' : '\u00A0'}
            </div>
            <div id="b4" />
        </div>
    );
};

export default Dealer;